import React from 'react';
import { motion } from 'framer-motion';
import { t } from 'i18next';
import { Brand_Cards_articles } from '../data/carddata';

const HalloweenPage = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1.5 } },
  };

  const maintitleVariants = {
    hidden: { x: 50, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 1, delay: 1 } },
  };

  const titleVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 1.5 } },
  };

  const textVariants = {
    hidden: { x: 20, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 1, delay: 2 } },
  };

  const textimgVariants = {
    hidden: { x: -20, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 1, delay: 2.5 } },
  };

  const productTextVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 3.5 } },
  };

  const productSectionVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, delay: 4 } },
  };

  return (
    <motion.div
      className="halloween-container bg-[#110f0e] overflow-hidden relative pt-[350px] pb-[150px] max-w-[2560px] w-full mx-auto flex flex-col items-center justify-center mobile:px-4"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="halloween-img-container relative">
        <div className="shape-small"></div>
        {/* <div className="bg-[#FFA500] w-full h-[550px]"></div> */}
        {/* <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-black to-transparent opacity-100"></div> */}
      </div>

      <motion.div
        className="halloween-title-container text-center mx-auto w-full"
        variants={titleVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="text-white text-[84px] Poppins font-bold mobile:text-[38px]">
          <span className="Butcherman block">🎃 Halloween 🎃</span> Trick or
          Treat!!
        </div>
        <h1 className="text-white/80 Pretendard-Regular mobile:text-[10px]">이벤트 기간 | 00.00(월) ~ 00.00(월)</h1>
      </motion.div>

      <motion.div
        className="halloween-maintitle-desc-container relative pt-[250px]"
        variants={maintitleVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="grid grid-cols-2 gap-[20px]  mobile:block">
          <motion.div
            className="flex justify-center"
            variants={textimgVariants}
            initial="hidden"
            animate="visible"
          >
            <div className="bg-[#FFA500] max-w-[500px] w-full h-[500px] ">이미지 부분</div>
          </motion.div>
          <motion.p
            className="text-white tracking-wide flex flex-col items-center justify-center"
            variants={textVariants}
            initial="hidden"
            animate="visible"
          >
            <div className="flex items-center gap-2 mobile:mt-[2rem]">
              <img
                src={`${process.env.PUBLIC_URL}/icon/fluent-emoji--candle (2).png`}
                className='mobile:w-[34px] mobile:h-[34px]'
              />
              <span className="text-[#FFA500] text-[38px] mobile:text-lg EF_jejudoldam text-center tracking-wide font-bold block mt-1">
                마인크래프트 할로윈 파티
              </span>
              <img
                src={`${process.env.PUBLIC_URL}/icon/fluent-emoji--candle (2).png`}
                className='mobile:w-[34px] mobile:h-[34px]'
              />
            </div>
            <div className="mt-[2rem] tracking-wide text-center leading-7 Pretendard-Regular text-base mobile:text-[11px] mobile:leading-[23px]">
              할로윈 시즌을 맞아 특별한 마인크래프트 상품을 만나보세요! <br />
              다양한 할로윈 테마의 아이템들이 준비되어 있어 <br />
              여러분의 세계를 더욱 신비롭고 재미있게 만들어 드립니다. <br />
              한정 기간 동안만 제공되는 특별한 상품들을 지금 바로 확인하고,
              <br />
              할로윈의 마법을 마인크래프트와 함께 즐겨보세요!
            </div>
          </motion.p>
        </div>
      </motion.div>

      <motion.div
        className="halloween-productTextVariants-content pt-[180px] mobile:pt-[120px]"
        variants={productTextVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="shape-small"></div>
        <div className="flex items-center gap-2">
          <img
            src={`${process.env.PUBLIC_URL}/icon/fluent-emoji--candle (2).png`}
            className='mobile:w-[34px] mobile:h-[34px]'
          />
          <span className="text-[#FFA500] text-[38px] mobile:text-lg EF_jejudoldam tracking-wide font-bold  mt-1">
            마인크래프트 할로윈 스페셜
          </span>
          <img
            src={`${process.env.PUBLIC_URL}/icon/fluent-emoji--candle (2).png`}
            className='mobile:w-[34px] mobile:h-[34px]'
          />
        </div>
        <div className="shape-small-r"></div>
      </motion.div>

      <motion.div
        className="pt-[4rem] mobile:pt-[3rem] halloween-productSectionVariants-content"
        variants={productSectionVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="shape-small-l"></div>
        <div className="relative">
          <div className="grid grid-cols-3 mobile:grid-cols-2 gap-14 mobile:gap-4">
            {Brand_Cards_articles.map((article) => (
              <div
                key={article.id}
                className="relative bg-[#131110b3] overflow-hidden rounded-[2rem] shadow-custom-box-shadow text-white transition-all w-full h-full duration-300 group"
              >
                <img
                  src={article.mainImg}
                  alt={article.title}
                  className="w-full h-64 mobile:h-auto object-cover"
                />
                <div className="pt-[1.4rem] pb-[1.6rem] px-[2rem] mobile:px-4 flex-auto relative w-full overflow-hidden gap-[.4rem] flex flex-col bottom-0">
                  <h3 className="leading-[2rem] text-lg mobile:text-sm Pretendard-Bold overflow-hidden text-ellipsis whitespace-nowrap w-[200px] mobile:w-[135px]">
                    {article.title}
                  </h3>
                  <div className="mt-10">
                    <div className="overflow-hidden gap-x-4 flex-1 flex flex-wrap items-center">
                      <p className="leading-[2.4rem] text-base mobile:text-[15px] Pretendard-Bold">
                        {article.price}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="
                            absolute inset-0 
                            bg-gray-900 bg-opacity-35 
                            backdrop-blur-lg
                            opacity-0 
                            group-hover:opacity-100 
                            transition-opacity duration-300 
                            flex flex-col justify-center items-center 
                            p-4 rounded-lg
                            cursor-pointer
                          "
                >
                  <div className="flex space-x-4 mb-6">
                    <button
                      className="border border-white/50 p-2 rounded-full"
                      aria-label={t('Add to Cart')}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="white"
                          fillRule="evenodd"
                          d="M9 8a3 3 0 1 1 6 0zM7 8a5 5 0 0 1 10 0h3a1 1 0 0 1 .996 1.09l-.835 9.182A3 3 0 0 1 17.174 21H6.826a3 3 0 0 1-2.987-2.728L3.004 9.09A1 1 0 0 1 4 8z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </button>
                    <button
                      className="border border-white/50 p-2 rounded-full"
                      aria-label={t('Favorite')}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="white"
                          d="M9.153 5.408C10.42 3.136 11.053 2 12 2s1.58 1.136 2.847 3.408l.328.588c.36.646.54.969.82 1.182s.63.292 1.33.45l.636.144c2.46.557 3.689.835 3.982 1.776c.292.94-.546 1.921-2.223 3.882l-.434.507c-.476.557-.715.836-.822 1.18c-.107.345-.071.717.001 1.46l.066.677c.253 2.617.38 3.925-.386 4.506s-1.918.051-4.22-1.009l-.597-.274c-.654-.302-.981-.452-1.328-.452s-.674.15-1.328.452l-.596.274c-2.303 1.06-3.455 1.59-4.22 1.01c-.767-.582-.64-1.89-.387-4.507l.066-.676c.072-.744.108-1.116 0-1.46c-.106-.345-.345-.624-.821-1.18l-.434-.508c-1.677-1.96-2.515-2.941-2.223-3.882S3.58 8.328 6.04 7.772l.636-.144c.699-.158 1.048-.237 1.329-.45s.46-.536.82-1.182z"
                        ></path>
                      </svg>
                    </button>
                  </div>

                  <hr className="border border-dotted border-white/30 w-full" />
                  <p className="text-sm Pretendard-Regular mobile:text-[11px] mb-2 mt-6">{article.description}</p>
                  <div className="flex flex-wrap justify-center space-x-2">
                    {article.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 Pretendard-Regular mobile:text-[11px] mobile:px-1 text-xs text-white/60"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default HalloweenPage;
